import { render, staticRenderFns } from "./SnackbarSuccess.vue?vue&type=template&id=2f7b8aca&lang=pug&"
import script from "./SnackbarSuccess.vue?vue&type=script&lang=js&"
export * from "./SnackbarSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports